import { z } from "zod";

import { WidgetDtoSchema } from "../../../dtos/widgets";

export const PutWidgetRequestBodySchema = z.object({
  widget: WidgetDtoSchema,
});

export type PutWidgetRequestBodyType = z.infer<
  typeof PutWidgetRequestBodySchema
>;

export const PutWidgetResponseBodySchema = z.object({
  widget: WidgetDtoSchema,
});
export type PutWidgetResponseBodyType = z.infer<
  typeof PutWidgetResponseBodySchema
>;
